import * as moment from '../../node_modules/moment/moment';
export class SaopRegCurrentTimeHelper {
    get_time(id_dogodka: string) {
        let casDogodka = $(id_dogodka).val();

        if (casDogodka !== undefined) {
            casDogodka = casDogodka + ":00";

            let casDogodka_list = casDogodka.split(":");
            let casDogodka_ms = (Math.abs(Number(casDogodka_list[0]) * 3600) + Math.abs(Number(casDogodka_list[1]) * 60)) * 1000;
            casDogodka_ms = casDogodka_list[0][0] == '-' ? casDogodka_ms * (-1) : casDogodka_ms;
            return casDogodka_ms;
        }

        return 0;
    }

    get_current_event_passed_time(id_zadnjega_dogodka: string): number {
    //podanemu času v ms doda čas od začetka zadnjega dogodka do trenutnega časa, če je zadnji dogodek še vedno aktiven (ni končan)

        // trenutni čas
        let currentTime = moment();
        let currentTime_ms = moment.duration(currentTime.format("HH:mm:ss")).asMilliseconds();

        //začetek zadnjega dogodka pred trenutnim časom
        let casZadnjegaDogodka = $(id_zadnjega_dogodka).val();

        //računanje tekoče dodanega časa
        let result_ms = 0;
        if (casZadnjegaDogodka !== undefined) {
            let uraZadnjegaDogodka_ms = moment.duration(casZadnjegaDogodka.toString()).asMilliseconds();

            if (uraZadnjegaDogodka_ms > 0)
                result_ms = currentTime_ms - uraZadnjegaDogodka_ms;
        }

        return result_ms;
    }

    format_time_string(result_ms: number): string {
        let isNegative = result_ms < 0;
        let result_s = Math.floor(Math.abs(result_ms)/1000);

        let hours = Math.floor(result_s / 3600);
        let minutes = Math.round((result_s - hours * 3600) / 60);
        if (minutes == 60) {
            minutes = 0
            hours = hours + 1;
        }
        //let seconds = Math.round(result_s - 3600 * hours - 60 * minutes);

        let hoursStr = hours;
        let minutesStr = (minutes < 10 ? "0" : "") + minutes;
        //let secondsStr = (seconds < 10 ? "0" : "") + seconds;

        let formattedDuration = hoursStr + ':' + minutesStr;
        //let formattedDuration = hoursStr + ':' + minutesStr + ':' + secondsStr;
        isNegative = isNegative && formattedDuration !== '0:00';
        const result = isNegative ? `-${formattedDuration}` : `+${formattedDuration}`;

        return result;
    }
}